// extracted by mini-css-extract-plugin
export default {"row":"Home_row__1zutb","loadingWrapper":"Home_loadingWrapper__wzKTi","colLeft":"Home_colLeft__tweUr","colRight":"Home_colRight__ZOsV+","col":"Home_col__fjiBC"};